<template>
  <div>
    <div>第一步  选组合关联商品（限10个）</div>
    <choseCommodity
        buttonName="+组合商品"
        :orgCode="orgCode"
        title="请选择组合商品"
        :categoryOptions="categoryOptions"
        :commodityList="commodityList"
        :searchData="searchData"
        @changeCommodityList = "changeCommodityList"
    ></choseCommodity>
    <div v-if="commodityTags.length > 0">第二步  组合优惠价设置</div>
    <el-table
        :data="commodityTags"
        style="width: 50%"
        v-if="specType == 0 && commodityTags.length > 0"
        border>
      <el-table-column
          prop="commodityId"
          label="组合商品"
          width="180"
          align="center"
          :formatter="name_formatter">
      </el-table-column>
      <el-table-column
          prop="price"
          label="组合价"
          align="center">
        <template slot-scope="{row,$index}">
          <el-input v-model="row.price" @change="changePrice" placeholder="组合价" size="small" style="width: 80%" @input="validateNumber(row.price,(data)=>{row.price = data})" maxLength='9'>
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
      
    </el-table>
  
    <el-table
        :data="modelTypeListData"
        max-height="500"
        :span-method="objectSpanMethod"
        v-if="specType == 1 && commodityTags.length > 0"
        border
        >
      <el-table-column
          v-for="col in modelTypeListMain"
          :prop="col.specName"
          :label="col.specName"
          fixed="left"
          min-width="150"
          align="center">
      </el-table-column>
      <el-table-column
          v-for="(commodityTag, index) in commodityTags"
          prop="commodityId"
          width="230"
          :index = "index"
          :render-header="titleHeader"
          align="center"
      
      >
        <template slot-scope="{row,$index}">
          <el-input v-model="row['price'+index]" @blur="changePrice1" placeholder="组合价" size="small" style="width: 80%" @input="validateNumber(row['price'+index],(data)=>{row['price'+index] = data})" maxLength='9'>
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

  import choseCommodity from './choseCommodity';
  
  export default {
    name: 'combinationCommodity',
    components: {choseCommodity},
    props: {
      modelTypeListDataMain: {
        type: Array,
        default: []
      },
      modelTypeListMain: {
        type: Array,
        default: []
      },
      combinedCommodityTempList: {
        type: Array,
        default: []
      },
      org: {
        type: Array,
        default: []
      },
      categoryOptions: {
        type: Array,
        default: []
      },
      spanArr: {
        type: Object,
        default: {}
      },
      specType: {
        type: Number,
        default: 0
      },
      skuCombinedPriceVoTempList: {
        type: Array,
        default: []
      },
      orgCode: {
        type: String,
        default: ''
      },
      excludeId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        choseCommodity: false,
        combinedCommodityList: [],
        choseCommoditys: [],
        combinationCommodityList: [],
        commodityTags: [],
        commodityList: [],
        skuCombinedPriceVoList: [],
        modelTypeListData: [],
        searchData: {
          size: 0,
          page: 1,
          courseName: '',
          ccId: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          orgCode: '',
          specType: 0,
          isView: 1,
          excludeId: this.excludeId
        }
      };
    },
    methods: {
      objectSpanMethod(item) {
        let row = item.row;
        let column = item.column;
        let field = column.property;
        let rowIndex = item.rowIndex;
        let columnIndex = item.columnIndex;
        if(this.spanArr[field]) {
          const _row = this.spanArr[field][rowIndex];
          return {
            rowspan: _row,
            colspan: 1
          };
        }

      },
      titleHeader(h, { column, $index }) {
        return h('span',{
          domProps: {
            innerHTML: '组合'+(column.index+1)+'个'
          }
        });
      },

      search(val) {
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        let params = this.searchData;
        this.https.fetchPost('/commodityInfo/selectListAll',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },

      changePrice1() {
        let skuPriceVoList = [];
        for(let data of this.modelTypeListData) {
          let skuPriceVo = {};
          let fieldTemp = {};
          const fields =  Object.keys(data);
          for(let field of fields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1) {
              fieldTemp[field] = data[field];
            }
          }
          let jsonData = JSON.stringify(fieldTemp);
          skuPriceVo.attributeName = jsonData;
          for(let i in this.commodityTags) {
            let temp = JSON.parse(JSON.stringify(skuPriceVo));
            temp['price'] = data['price'+i];
            temp['combinedCommoditNum'] = Number.parseInt(i)+1;
            skuPriceVoList.push(temp);
          }
        }
        this.$emit('changeSkuCombinedPriceVoList', skuPriceVoList);
      },
      
      changePrice() {
        let skuCombinedPriceVoList = [];
        for(let commodity of this.commodityTags) {
          let combinedCommoditNum = this.commodityTags.indexOf(commodity)+1;
          let skuCombinedPrice = {};
          skuCombinedPrice.combinedCommoditNum = combinedCommoditNum;
          skuCombinedPrice.price = commodity.price?Number.parseFloat(commodity.price):0;
          skuCombinedPriceVoList.push(skuCombinedPrice);
        }
        this.skuCombinedPriceVoList = skuCombinedPriceVoList;
        this.$emit('changeSkuCombinedPriceVoList', skuCombinedPriceVoList);
      },

      changeCommodityList(choseCommoditys) {
        
        if(this.skuCombinedPriceVoList.length > choseCommoditys.length) {
          for(let i=0; i<this.skuCombinedPriceVoList.length -choseCommoditys.length; i++) {
            this.skuCombinedPriceVoList.pop();
          }
          this.$emit('changeSkuCombinedPriceVoList', this.skuCombinedPriceVoList);
        }
        this.commodityTags = [];
        for(let commodity of choseCommoditys) {
          let tag = {};
          tag.courseName = commodity.courseName;
          tag.commodityId = commodity.commodityId;
          if(this.specType == 0) {
            let index = choseCommoditys.indexOf(commodity);
            if(index < this.skuCombinedPriceVoList.length) {
              this.$set(tag, 'price', this.skuCombinedPriceVoList[index].price);
            }
          }
          this.commodityTags.push(tag);
        }
        
        if(this.specType == 1) {
        
        }
        
        let commbinedCommodityList = [];
        for(let commodity of choseCommoditys) {
          let combinedCommodity = {};
          combinedCommodity.commbinedCommodityId = commodity.commodityId;
          commbinedCommodityList.push(combinedCommodity);
        }
        this.combinedCommodityList = commbinedCommodityList;
        this.$emit('changeCombinedCommodityList',this.combinedCommodityList);
        
      },
      
      name_formatter(item , e, row, index) {
          return '组合'+(index+1) + '个';
      },
      validateNumber(value,collback) {
        value = value.replace(/[^\d.]/g,''); // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g,''); // 验证第一个字符是数字
        value = value.replace(/\.{2,}/g,'.'); // 只保留第一个, 清除多余的
        value = value.replace('.','$#$').replace(/\./g,'').replace('$#$','.');
        // 保存n个小数
        value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');         // 只能输入n个小数
        if(value.indexOf('.') < 0 && value !=''){
          value = parseFloat(value);
          value = (value+'').substr(0,6);
        } else {
          let value1 = value.substr(0,value.indexOf('.')).substr(0,6);
          let value2 = value.substr(value.indexOf('.'));
          value = value1+value2;
        }
        value = isNaN(value) ? 0 : value; // 不让显示NAN

        collback(value);
      },
      
      initCombinedCommodityTempList(newVal,oldVal) {
        this.commodityList = [];
        for(let combinedCommodity of newVal) {
          let commodity = {};
          commodity.recommendName = combinedCommodity.commbinedCommodityName;
          commodity.recommendId = combinedCommodity.commbinedCommodityId;
          this.commodityList.push(commodity);
        }
        this.commodityTags = JSON.parse(JSON.stringify(newVal));
        if(this.spceType == 0) {
          for(let i in this.skuCombinedPriceVoTempList) {
            // this.commodityTags[i].price = this.skuCombinedPriceVoTempList[i].price;
            let commodityTag = this.commodityTags[i];
            this.$set(commodityTag, 'price', this.skuCombinedPriceVoTempList[i].price);
          }
        }
        if(this.spceType == 1) {

        }
        this.skuCombinedPriceVoList = JSON.parse(JSON.stringify(this.skuCombinedPriceVoTempList));
      },
      
      initModelTypeListDataMain(newVal,oldVal) {
        let temp = [];
        for(let nVal of newVal) {
          let flag = false;
          let newValFieldTemp = {};
          const fields =  Object.keys(nVal);
          for(let field of fields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1) {
              newValFieldTemp[field] = nVal[field];
            }
          }

          for(let oVal of this.modelTypeListData) {
            let newOldFieldTemp = {};
            const oldFields =  Object.keys(this.modelTypeListData);
            for(let oldField of oldFields) {
              if(oldField.indexOf('rice') == -1 && oldField.indexOf('skuId') == -1) {
                newOldFieldTemp[oldField] = this.modelTypeListData[oldField];
              }
            }

            if(JSON.stringify(newValFieldTemp) == JSON.stringify(newOldFieldTemp)) {
              temp.push(oVal);
              flag = true;
            }

          }
          if(!flag) {
            if(this.commodityTags.length > 0) {
              for(let i in this.commodityTags) {
                newValFieldTemp['price'+i] = '';
              }
            }
            temp.push(newValFieldTemp);
          }
        }

        this.modelTypeListData = JSON.parse(JSON.stringify(temp));

        for(let skuPrice of this.skuCombinedPriceVoTempList) {
          const fieldTemp = {};
          for(let data of this.modelTypeListData) {
            const fields1 =  Object.keys(data);
            for(let field of fields1) {
              if(field.indexOf('price') == -1 && field.indexOf('skuId') == -1) {
                fieldTemp[field] = data[field];
              }
            }
            let s = JSON.stringify(fieldTemp);
            if(s == skuPrice.attributeName) {
              for(let field of fields1) {
                if(field.indexOf('price') > -1) {
                  let i = field.substr(5);
                  if(Number.parseInt(i)+1 == skuPrice.combinedCommoditNum) {
                    data[field] = skuPrice.price;
                  }
                }
              }
            }
          }
        }
      },
      initskuCombinedPriceVoTempList(newVal,oldVal) {
        for(let i in this.skuCombinedPriceVoTempList) {
          // this.commodityTags[i].price = this.skuCombinedPriceVoTempList[i].price;
          let commodityTag = this.commodityTags[i];
          this.$set(commodityTag, 'price', this.skuCombinedPriceVoTempList[i].price);
        }
      },
      
      initCommodityTags(newVal,oldVal) {
        if(newVal.length > oldVal.length) {
          for(let i = oldVal.length; i< newVal.length; i++ ) {
            for(let modelType of this.modelTypeListData) {
              this.$set(modelType, 'price'+i, '');
            }
          }
        }
      },
    },
    watch: {
      combinedCommodityTempList: function(newVal,oldVal) {
        this.combinedCommodityList = newVal;
        this.initCombinedCommodityTempList(newVal,oldVal);
      },
      modelTypeListMain: function(newVal,oldVal) {
      },

      commodityTags: function(newVal,oldVal) {
        this.initCommodityTags(newVal,oldVal);
      },
      
      modelTypeListDataMain: function(newVal, oldVal) {
        this.initModelTypeListDataMain(newVal, oldVal);
      },

      skuCombinedPriceVoTempList: function(newVal, oldVal) {
       this.initskuCombinedPriceVoTempList();
      },

    },
    
    created: function() {
    
    }
  };
</script>

<style scoped>

</style>
